import { render, staticRenderFns } from "./PoliticallyExposedPersonInfo.vue?vue&type=template&id=b15baf10&"
import script from "./PoliticallyExposedPersonInfo.vue?vue&type=script&lang=js&"
export * from "./PoliticallyExposedPersonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports